(function () {
  var root = document.documentElement;
  var moneyFormat = root.getAttribute("data-money-format") || "${{amount}}";
  var threshold = parseInt(root.getAttribute("data-stock-threshold") || "8", 10);

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(".", ","))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(cents / 100)));
  }

  function lock(on) {
    document.body.classList.toggle("sw-lock", on);
  }

  var menu = document.querySelector("[data-sw-menu]");
  var menuOpen = document.querySelector("[data-sw-menu-open]");
  var menuClose = document.querySelector("[data-sw-menu-close]");

  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle("is-open", open);
    if (menuOpen) menuOpen.setAttribute("aria-expanded", open ? "true" : "false");
    lock(open || document.querySelector("[data-sw-drawer].is-open"));
    if (open && menuClose) menuClose.focus();
  }

  if (menuOpen) menuOpen.addEventListener("click", function () { setMenu(true); });
  if (menuClose) menuClose.addEventListener("click", function () { setMenu(false); });
  if (menu) {
    menu.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () { setMenu(false); });
    });
  }

  var overlay = document.querySelector("[data-sw-overlay]");
  var drawer = document.querySelector("[data-sw-drawer]");
  var cartBody = document.querySelector("[data-sw-cart-body]");
  var cartFoot = document.querySelector("[data-sw-cart-foot]");
  var cartCount = document.querySelector("[data-sw-cart-count]");

  function setCart(open) {
    if (!drawer) return;
    drawer.classList.toggle("is-open", open);
    if (overlay) overlay.classList.toggle("is-open", open);
    drawer.setAttribute("aria-hidden", open ? "false" : "true");
    lock(open);
    if (open) {
      var close = drawer.querySelector("[data-sw-cart-close]");
      if (close) close.focus();
    }
  }

  document.querySelectorAll("[data-sw-cart-open]").forEach(function (el) {
    el.addEventListener("click", function (event) {
      event.preventDefault();
      setCart(true);
    });
  });
  document.querySelectorAll("[data-sw-cart-close]").forEach(function (el) {
    el.addEventListener("click", function () { setCart(false); });
  });
  if (overlay) overlay.addEventListener("click", function () { setCart(false); });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    setMenu(false);
    setCart(false);
    closePopup();
  });

  function lineHtml(item) {
    var meta = item.variant_title && item.variant_title !== "Default Title"
      ? '<p class="sw-micro">' + item.variant_title + "</p>"
      : "";
    return (
      '<article class="sw-line">' +
        "<div><p><strong>" + item.product_title + "</strong></p>" + meta +
        '<div class="sw-line__qty">' +
          '<button type="button" data-sw-qty="-1" data-key="' + item.key + '" aria-label="Decrease quantity">−</button>' +
          "<span>" + item.quantity + "</span>" +
          '<button type="button" data-sw-qty="1" data-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
          '<button type="button" data-sw-remove data-key="' + item.key + '">Remove</button>' +
        "</div></div>" +
        "<p>" + formatMoney(item.final_line_price) + "</p>" +
      "</article>"
    );
  }

  function renderCart(cart) {
    if (cartCount) {
      cartCount.textContent = cart.item_count ? String(cart.item_count) : "";
      cartCount.setAttribute("data-count", String(cart.item_count));
    }
    if (!cartBody) return;
    if (!cart.item_count) {
      cartBody.innerHTML = "<h3>Your cart is empty</h3><p>Pick a book your kid will actually reach for.</p><p><a class=\"sw-btn\" href=\"/collections/all\">Browse the books</a></p>";
      if (cartFoot) cartFoot.hidden = true;
      return;
    }
    cartBody.innerHTML = cart.items.map(lineHtml).join("");
    if (cartFoot) {
      cartFoot.hidden = false;
      var total = cartFoot.querySelector("[data-sw-total]");
      if (total) total.textContent = formatMoney(cart.total_price);
    }
  }

  function refreshCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (res) { return res.json(); }).then(renderCart);
  }

  if (cartBody) {
    cartBody.addEventListener("click", function (event) {
      var qty = event.target.closest("[data-sw-qty]");
      var remove = event.target.closest("[data-sw-remove]");
      if (!qty && !remove) return;
      var key = (qty || remove).getAttribute("data-key");
      if (remove) {
        changeLine(key, 0);
        return;
      }
      var current = parseInt(qty.parentNode.querySelector("span").textContent, 10) || 1;
      var next = current + parseInt(qty.getAttribute("data-sw-qty"), 10);
      changeLine(key, Math.max(0, next));
    });
  }

  var giftBox = document.querySelector("[data-sw-gift]");
  var giftNote = document.querySelector("[data-sw-note]");
  var noteTimer;

  function saveCartMeta() {
    var payload = {
      note: giftNote ? giftNote.value : "",
      attributes: {
        gift: giftBox && giftBox.checked ? "Plain packaging, no prices inside" : ""
      }
    };
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload)
    });
  }

  if (giftBox) giftBox.addEventListener("change", saveCartMeta);
  if (giftNote) {
    giftNote.addEventListener("input", function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(saveCartMeta, 400);
    });
  }

  var form = document.querySelector("[data-sw-product-form]");
  var status = document.querySelector("[data-sw-status]");

  function selectedPack() {
    return document.querySelector("[data-sw-pack]:checked");
  }

  function applyPack() {
    var pack = selectedPack();
    var select = document.querySelector("[data-sw-id]");
    if (!pack || !select) return;
    select.value = pack.value;
    select.dispatchEvent(new Event("change", { bubbles: true }));
    document.querySelectorAll("[data-sw-price]").forEach(function (el) {
      el.textContent = pack.getAttribute("data-price");
    });
    var gallery = document.querySelector("[data-sw-gallery]") || document.querySelector(".sw-pdp__gallery img");
    var nextImage = pack.getAttribute("data-image");
    if (gallery && nextImage) {
      gallery.removeAttribute("srcset");
      gallery.src = nextImage;
      var nextAlt = pack.getAttribute("data-image-alt");
      if (nextAlt) gallery.alt = nextAlt;
    }
    var stock = document.querySelector("[data-sw-stock]");
    if (!stock) return;
    var available = pack.getAttribute("data-available") === "true";
    var managed = pack.getAttribute("data-managed") === "true";
    var policy = pack.getAttribute("data-policy");
    var qty = parseInt(pack.getAttribute("data-qty") || "0", 10);
    stock.className = "sw-stock";
    if (!available) {
      stock.textContent = stock.getAttribute("data-sold-out") || "Sold out.";
      stock.classList.add("sw-stock--out");
    } else if (managed && policy === "deny" && qty > 0 && qty <= threshold) {
      stock.textContent = qty + " in stock.";
      stock.classList.add("sw-stock--low");
    } else {
      stock.textContent = stock.getAttribute("data-in-stock") || "In stock. Ships within 1–2 business days.";
    }
  }

  document.querySelectorAll("[data-sw-pack]").forEach(function (pack) {
    pack.addEventListener("change", applyPack);
  });

  if (form) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var button = form.querySelector("[data-sw-atc]");
      var select = form.querySelector("[data-sw-id]");
      if (!select) return;
      var items = [{ id: Number(select.value), quantity: 1 }];
      var upsell = document.querySelector("[data-sw-upsell]");
      if (upsell && upsell.checked && upsell.value) {
        items.push({ id: Number(upsell.value), quantity: 1 });
      }
      if (button) {
        button.disabled = true;
        button.classList.add("is-busy");
      }
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (!res.ok) throw new Error("add failed");
        return refreshCart();
      }).then(function () {
        setCart(true);
        if (status) status.hidden = true;
      }).catch(function () {
        if (status) {
          status.hidden = false;
          status.textContent = "We could not add that to the cart. Please try again.";
        }
      }).finally(function () {
        if (button) {
          button.classList.remove("is-busy");
          var pack = selectedPack();
          button.disabled = !!(pack && pack.getAttribute("data-available") !== "true");
        }
      });
    });
  }

  document.querySelectorAll("[data-sw-sticky-atc]").forEach(function (button) {
    button.addEventListener("click", function () {
      var main = document.querySelector("[data-sw-atc]");
      if (main) main.click();
    });
  });

  var buy = document.querySelector("[data-sw-buy]");
  var sticky = document.querySelector("[data-sw-sticky]");
  if (buy && sticky && "IntersectionObserver" in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle("is-visible", show);
        document.body.classList.toggle("sw-sticky-on", show);
      });
    }, { threshold: 0 });
    observer.observe(buy);
  }

  document.querySelectorAll("[data-sw-acc]").forEach(function (group) {
    group.addEventListener("click", function (event) {
      var btn = event.target.closest("[data-sw-acc-btn]");
      if (!btn || !group.contains(btn)) return;
      var item = btn.closest("[data-sw-acc-item]");
      var willOpen = !item.classList.contains("is-open");
      group.querySelectorAll("[data-sw-acc-item]").forEach(function (other) {
        other.classList.remove("is-open");
        var otherBtn = other.querySelector("[data-sw-acc-btn]");
        if (otherBtn) otherBtn.setAttribute("aria-expanded", "false");
      });
      if (willOpen) {
        item.classList.add("is-open");
        btn.setAttribute("aria-expanded", "true");
      }
    });
  });

  function setupTickers(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var bars = root.querySelectorAll("[data-sw-ticker-root]");
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    bars.forEach(function (bar) {
      var track = bar.querySelector("[data-sw-ticker]");
      var group = bar.querySelector("[data-sw-ticker-source]");
      if (!track || !group) return;
      bar.querySelectorAll("[data-sw-clone]").forEach(function (node) { node.remove(); });
      bar.classList.remove("is-ready");
      if (reduce) return;
      var width = group.getBoundingClientRect().width;
      var view = bar.clientWidth;
      if (width < 2 || view < 2) return;
      var copies = Math.ceil(view / width) + 1;
      for (var i = 1; i < copies; i++) {
        var clone = group.cloneNode(true);
        clone.removeAttribute("data-sw-ticker-source");
        clone.setAttribute("data-sw-clone", "");
        clone.setAttribute("aria-hidden", "true");
        track.appendChild(clone);
      }
      track.style.setProperty("--sw-shift", (-width) + "px");
      track.style.setProperty("--sw-duration", (width / 24) + "s");
      bar.classList.add("is-ready");
    });
  }

  setupTickers(document);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { setupTickers(document); });
  }
  var tickerTimer;
  window.addEventListener("resize", function () {
    clearTimeout(tickerTimer);
    tickerTimer = setTimeout(function () { setupTickers(document); }, 150);
  });
  document.addEventListener("shopify:section:load", function (event) {
    setupTickers(event.target);
  });

  var country = document.querySelector("[data-sw-country]");
  if (country) {
    country.addEventListener("change", function () {
      country.form.submit();
    });
  }

  var popup = document.querySelector("[data-sw-popup]");
  var popupOverlay = document.querySelector("[data-sw-popup-overlay]");
  var popupKey = "sw-sunday-why";

  function closePopup() {
    if (!popup) return;
    popup.classList.remove("is-open");
    if (popupOverlay) popupOverlay.classList.remove("is-open");
    popup.setAttribute("aria-hidden", "true");
    try { localStorage.setItem(popupKey, "1"); } catch (err) { /* ignore */ }
  }

  function openPopup() {
    if (!popup) return;
    popup.classList.add("is-open");
    if (popupOverlay) popupOverlay.classList.add("is-open");
    popup.setAttribute("aria-hidden", "false");
  }

  document.querySelectorAll("[data-sw-popup-close]").forEach(function (el) {
    el.addEventListener("click", closePopup);
  });
  if (popupOverlay) popupOverlay.addEventListener("click", closePopup);

  var seen = false;
  try { seen = localStorage.getItem(popupKey) === "1"; } catch (err) { seen = true; }
  if (popup && !seen && window.matchMedia("(pointer:fine)").matches) {
    document.addEventListener("mouseout", function (event) {
      if (seen) return;
      if (event.clientY <= 0 && !event.relatedTarget) {
        seen = true;
        openPopup();
      }
    });
  }

  document.querySelectorAll("[data-sw-thumb]").forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      var main = document.querySelector(".sw-pdp__gallery img");
      if (!main) return;
      main.removeAttribute("srcset");
      main.src = thumb.getAttribute("data-full");
      main.alt = thumb.getAttribute("data-alt") || main.alt;
    });
  });
})();
